module.exports = __webpack_public_path__ + "img/int8.685b40c3.jpg";